import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Crown } from 'lucide-react';
import { cn } from '@/lib/utils';

interface InstantAccountBadgeProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const InstantAccountBadge = ({ className, size = 'md' }: InstantAccountBadgeProps) => {
  const sizeClasses = {
    sm: 'text-xs px-2 py-1',
    md: 'text-sm px-3 py-1',
    lg: 'text-base px-4 py-2'
  };

  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4', 
    lg: 'h-5 w-5'
  };

  return (
    <Badge
      className={cn(
        'bg-gradient-to-r from-amber-500 to-yellow-600 text-white border-0 font-semibold animate-pulse',
        sizeClasses[size],
        className
      )}
    >
      <Crown className={cn('mr-1', iconSizes[size])} />
      INSTANT ACCOUNT
    </Badge>
  );
};